import {
  APP_SETTING_SAVE_JS_FILE_BEGIN,
  APP_SETTING_SAVE_JS_FILE_SUCCESS,
  APP_SETTING_SAVE_JS_FILE_FAILURE,
  APP_SETTING_SAVE_JS_FILE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function saveJsFile(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_SAVE_JS_FILE_BEGIN,
    });
    const header = {
      'Content-Type': 'multipart/form-data',
    };
    const { projectId, jsuuid, formData, version, customJsCdnData } = args;
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/${customJsCdnData.customType}/custom-js-cdn/files/${jsuuid}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, formData, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_SAVE_JS_FILE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_SAVE_JS_FILE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveJsFileError() {
  return {
    type: APP_SETTING_SAVE_JS_FILE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_SAVE_JS_FILE_BEGIN:
      return {
        ...state,
        saveJsFilePending: true,
        saveJsFileError: null,
      };

    case APP_SETTING_SAVE_JS_FILE_SUCCESS:
      return {
        ...state,
        saveJsFilePending: false,
        saveJsFileError: null,
      };

    case APP_SETTING_SAVE_JS_FILE_FAILURE:
      return {
        ...state,
        saveJsFilePending: false,
        saveJsFileError: action.data.error,
      };

    case APP_SETTING_SAVE_JS_FILE_DISMISS_ERROR:
      return {
        ...state,
        saveJsFileError: null,
      };

    default:
      return state;
  }
}
